// ui/web/src/components/buzz/BuzzLoadingState.tsx
export function BuzzLoadingState() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-3 text-[var(--text-02)]">
      <div className="size-8 border-2 border-[var(--color-primary)] border-t-transparent rounded-full animate-spin" />
      <p className="text-sm">Connecting to Buzz…</p>
    </div>
  )
}
